import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "background-modal" }
const _hoisted_2 = { class: "wrapper-modal" }
const _hoisted_3 = { class: "wrapper-title" }
const _hoisted_4 = { class: "wrapper-images" }
const _hoisted_5 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CloseButton = _resolveComponent("CloseButton")!
  const _component_PrevNextButton = _resolveComponent("PrevNextButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[0] || (_cache[0] = _createElementVNode("p", { class: "title" }, "Imágenes", -1)),
        _createVNode(_component_CloseButton, { onClick: _ctx.closeModal }, null, 8, ["onClick"])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_PrevNextButton, {
          type: "Prev",
          class: "prev",
          isDisabled: !_ctx.countImages,
          onClick: _ctx.backSlider
        }, null, 8, ["isDisabled", "onClick"]),
        _createElementVNode("img", {
          src: _ctx.currentImage,
          alt: "",
          class: "image"
        }, null, 8, _hoisted_5),
        _createVNode(_component_PrevNextButton, {
          type: "Next",
          class: "next",
          isDisabled: !_ctx.countImages,
          onClick: _ctx.nextSlider
        }, null, 8, ["isDisabled", "onClick"])
      ])
    ])
  ]))
}